export const setNavigationPath = (tabValue) => ({
    type: 'SET_NAVIGATION_PATH',
    payload: tabValue,
  });
  export const setSelectedDataId = (dataId) => ({
    type: 'SET_SELECTED_DATA_ID',
    payload: dataId,
  });